var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstractAvatar31SquareStreamlineAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 513 513",
    height: 100,
    width: 100,
    strokeWidth: 1,
    id: "Abstract-Avatar-31-Square--Streamline-Abstract.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Abstract Avatar 31 Square Streamline Emoji: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M.694.871h512v512h-512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce51",
    d: "M66.7764 591.062H446.776V136.59l-190 109.789L66.7764 136.59v454.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "m196.276 356.59 24-14.002-23.57-13.998"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "m316.276 356.59-24-14.002 23.571-13.998"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M226.276 396.59c16.57 15.998 43.433 16 60 .004"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 0h512v512H0z",
    transform: "translate(.276 .59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractAvatar31SquareStreamlineAbstract);
export default __webpack_public_path__ + "static/media/Abstract-Avatar-31-Square--Streamline-Abstract.99be43ba5ab533de1f3b54503f2d513b.svg";
export { ForwardRef as ReactComponent };